// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-9de730e0] .p-progressbar-value::before {\r\n    background-color: #286eb6 !important;\n}\n[data-v-9de730e0] .p-progressbar-value::after {\r\n    background-color: #286eb6 !important;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
